import React from "react";

export default class AdminPage<T, U> extends React.Component<T, U> {
    static requiresAuth = true;
    static requiresAdmin = true;
}
